import { useRef, useEffect } from "react"
import { Pannellum } from "pannellum-react"
import { io } from "socket.io-client"
import cross from "../FavouritesForm/cross.svg"
import { useStore } from "../../state/store"
import "./Viewer360.css"
import { blockFViewMapper } from "../../ApartmentFinderConfig/blockFViewMapper"

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE
export default function Viewer360({ block, floor, setShow, activeApt, id }) {
  const isMultiView = typeof blockFViewMapper[activeApt] === "object"

  let floorFormat

  const viewer = useRef()
  const socket = useRef()

  if (floor.charAt(0) === 0) {
    floorFormat = Number(floor)
  } else {
    floorFormat = floor
  }

  const viewID = useStore(state => state.viewID)

  console.log(viewID, "VIEW ID", viewID.length)
  const showRecipient360 = useStore(state => state.showRecipient360)
  const setShowRecipient360 = useStore(state => state.setShowRecipient360)

  console.log("activeApt ::", activeApt, "viewID", viewID)

  const moved = () => {
    if (viewer.current && socket.current && role === "sender") {
      socket.current.emit("panorama", [
        viewer.current?.getViewer().getPitch(),
        viewer.current?.getViewer().getYaw(),
        viewer.current?.getViewer().getHfov()
      ])
    }
  }

  useEffect(() => {
    if (url && role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("panorama", data => {
          if (viewer.current) {
            viewer.current?.getViewer().lookAt(data[0], data[1], data[2])
          }
        })
      }
    }
  }, [])

  const floorMapper = {
    "0": "1",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "3",
    "5": "3",
    "6": "5",
    "7": "5",
    "8": "7",
    "9": "7",
    "10": "10"
  }
  const floorMapperthrees = {
    "0": "1",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10"
  }

  const imgUrl = activeApt.includes("H")
    ? viewID === "courtyard"
      ? `${
          process.env.PUBLIC_URL || "/"
        }assets/apartmentfinder/images/views/360/H/${activeApt}_Copy.jpg`
      : `${process.env.PUBLIC_URL || "/"}assets/apartmentfinder/images/views/360/H/${activeApt}.jpg`
    : block === "J"
    ? `${process.env.PUBLIC_URL || "/"}assets/apartmentfinder/images/views/360/J/${id}.jpg`
    : block === "F"
    ? `${process.env.PUBLIC_URL || "/"}assets/apartmentfinder/images/views/360/F/${
        isMultiView
          ? blockFViewMapper[activeApt][viewID === "north" ? 1 : 0]
          : blockFViewMapper[activeApt]
      }.jpg`
    : `${process.env.PUBLIC_URL || "/"}assets/apartmentfinder/images/views/360/${block}/${
        activeApt.split(".")[2] === "03" ? floorMapperthrees[floorFormat] : floorMapper[floorFormat]
      }.0${activeApt?.split(".")[2]}.jpg`

  const studioView = `${
    process.env.PUBLIC_URL || "/"
  }assets/apartmentfinder/images/views/360/E/studioview.jpg`

  const stillImgUrl = `${process.env.PUBLIC_URL || "/"}assets/apartmentfinder/images/views/360/k/0${
    floorMapper[floorFormat]
  }.${"01"}_a.jpg`

  console.log("VIEW IMAGE", imgUrl, activeApt)

  useEffect(() => {
    if (url && role === "recipient") {
      socket.current = io(url)
      socket.current.on("destroy", data => {
        console.dir(viewer.current?.getViewer().getRenderer().getCanvas())
      })
    }

    return () => viewer.current?.getViewer().destroy()
  }, [])

  useEffect(() => {
    console.log(imgUrl)
  }, [imgUrl])

  const handleClose = () => {
    viewer.current?.getViewer().destroy()
    console.log(viewer.current?.getViewer())
    socket.current?.emit("destroy", true)
    setTimeout(() => {
      setShow(false)
    }, 20)
  }

  return (
    <>
      <div
        style={{
          zIndex: "1",
          position: "absolute",
          height: "100%",
          width: "100%",
          opacity: role === "recipient" ? (showRecipient360 ? 1 : 0) : 1
        }}
      >
        {block === "K" ? (
          <div style={{ width: "100%", height: "100%" }}>
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
              src={stillImgUrl}
              alt="View from K"
            />
          </div>
        ) : activeApt + block !== "01E" ? (
          <Pannellum
            northOffset={180}
            ref={viewer}
            width="100%"
            height="100%"
            image={imgUrl}
            pitch={0}
            yaw={block === "J" ? 0 : 180}
            hfov={110}
            autoLoad
            onRender={() => moved()}
            showZoomCtrl={false}
          />
        ) : (
          <div style={{ width: "100%", height: "100%" }}>
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
              src={studioView}
              alt="View from K"
            />
          </div>
        )}
        <img
          style={{
            margin: "20px",
            cursor: "pointer",
            top: "0",
            right: "0",
            position: "absolute",
            zIndex: 99999999,
            height: "40px",
            width: "40px"
          }}
          src={cross}
          alt="close"
          className="cross"
          onClick={handleClose}
        />
        {role === "sender" && (
          <img
            alt="views"
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/views.svg`}
            style={{
              position: "absolute",
              zIndex: 1,
              bottom: 15,
              left: 15,
              cursor: "pointer",
              opacity: showRecipient360 ? 1 : 0.5,
              transition: ".3s"
            }}
            onClick={() => setShowRecipient360(!showRecipient360)}
          />
        )}
      </div>
    </>
  )
}
